<footer class="d-flex align-items-center justify-content-center text-muted flex-column pt-3 pb-3">
  {{'footer.title'|translate}}
  <a
    class="pt-1"
    [href]="'assets/files/' + (translateService.currentLang === 'fr' ? 'FR - CGU&DP' : translateService.currentLang === 'en' ? 'ENG- CGU&DP' : 'ESP - CGU&DP') + '.docx'"
    [download]="(translateService.currentLang === 'fr' ? 'FR - CGU&DP' : translateService.currentLang === 'en' ? 'ENG- CGU&DP' : 'ESP - CGU&DP') + '.docx'">
    {{'footer.CGU'|translate}}
  </a>
</footer>
